// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._30i9K {
  margin: 0;
  padding: 0;
}

._30i9K * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

._3kSzL {
  background-color: black;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}

._tCjNO {
  padding-bottom: 2px;
}

._2IJEr:hover,
._2IJEr:focus,
._2Yv4j svg:hover,
._2Yv4j svg:focus,
._1lgEi span:hover,
._DDceb:hover,
._2Vept:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

/* On hover, add a black background color with a little bit see-through */
._2gxOL:hover,
._3gp2w:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

._2crlL {
  display: flex;
}

._34QvR {
  display: none;
}

._1R214 {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

img._3EuZy {
  transition: 0.3s;
}

._3EuZy:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

._DDceb {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

._1lgEi {
  left: 2%;
  padding-right: 2vw;
}


._3pfLz {
  transition: border 0.3s;
}

._1R214 {
  display: inline;
}

._Fp_rP {
  width: 90%;
}

._1jASN {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  ._22ETc {
    height: 67vw;
    width: 60%;
  }

  ._-wN_b {
    position: fixed;
    bottom: 5%;
    width: 100vw;
    /* width: 100%; */
  }

  ._2b4P7 ._1yWyS {
    height: 100vh;
  }


  ._2b4P7 ._1JRT_ {
    top: 0;
  }

  ._1R214 {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  ._KbOLW {
    bottom: 2%;
  }

  ._1j-pZ {
    padding-bottom: 16px;
    width: 100vw;
  }

  ._3pfLz {
    margin-left: auto;
    margin-right: auto;
  }

  ._DDceb {
    right: 0.9%;
  }

  ._1lgEi {
    left: 1.5%;
  }
}

._1R214 {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}

._-wN_b {
  position: absolute;
  bottom: 10%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

._1Odla {
  width: 78vw;
}

._KbOLW {
  bottom: 5%;
}

._1nxK_ {
  height: 19vh;
}

._z-jNd video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

._2jJU2 {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

._lY1R_ {
  cursor: pointer;
  margin: 0.2em;
}

._PH6f8 {
  width: 99vw;
  height: 100%;
  max-height: 100%;
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

._wTR3b {
  height: 100%;
  max-height: 100%;
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

._11N04 img {
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
}

._20Hp6 img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

._20Hp6 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._3PObS {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

._1JRT_ {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 10%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._29Kdn {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
}

._1ni2w {
  top: 6%;
}

._GV0NM {
  top: 12%;
}

._2b4P7  {
  top: 0;
}

._11N04 {
  top: 0;
}

._3BNPD {
  width: 100vw;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

._DDceb,
._1lgEi {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
}



._DDceb:hover,
._1lgEi:hover {
  color: rgb(230, 230, 230);
}

._j1nqC {
  position: absolute;
  max-width: 100vw;
}

._ABXHD {
  display: flex;
  flex-direction: row;
  align-items: center;
}

._2Yv4j {
  color: white;
  position: absolute;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  top: 10px;
  right: 45px;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

._2eq8V {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

._1P3Wc {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

._z-jNd {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._Aq8HC, ._w68I8 {
  margin-left: auto;
  margin-right: auto;
}

._qtY0U {
  position: fixed;
  top: 4%;
  right: 3%;
}

._3cxVN ._2Yv4j svg {
  transition: 0.3s all;
}

._2Yv4j svg:active {
  transform: scale(0.97);
}

._2pA2G {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._2Yv4j svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

._2Vept {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  ._2Yv4j {
    top: 3%;
  }

  ._wTR3b {
    width: 100vw;
  }

  ._2Yv4j svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  ._30i9K img {
    cursor: pointer;
  }

  ._1R214 {
    height: 9vh;
    /* width: 22vw; */
  }

  ._DDceb {
    top: calc(48% - 20px);
  }

  ._1lgEi {
    top: calc(48% - 20px);

  }


}

@media screen and (min-width: 39em) {
  ._wTR3b {
    width: 100vw;
  }

  ._1JRT_ {
    width: 100vw;
    height: 95vh;
    position: absolute;
  }

  ._1j-pZ {
    padding-bottom: 0px;
  }

  ._DDceb {
    right: 0.7%;
  }

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */



  ._11N04 {
    width: 100vw;
    height: 100vh;
  }

  ._11N04 img {
    height: 100vh;
  }

  ._3pfLz {
    margin-top: 0.6em;
  }

  ._1R214 {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  ._2Yv4j svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  ._1lgEi {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  ._22ETc {
    height: 70vh;
    width: 80vw;
  }

  ._2yYOi {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  ._1JRT_ img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  ._11N04 img {
    width: 100vw;
  }

  ._hWNoE {
    top: 0%;
  }

  ._1ek8k {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  ._hWNoE {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  ._hWNoE img {
    object-fit: contain;
  }

  ._3pfLz {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  ._3pfLz::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ._2P48G {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  ._-wN_b {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
    /* width: 90vw; */
  }

  ._1R214,
  ._1xBL9 img {
    height: 10vh;
    /* width: 7em; */
  }

  ._wTR3b {
    width: 100vw;
  }

  ._1JRT_ {
    width: 100vw;
    height: 95vh;
  }

  ._2b4P7 {
    height: 100vh;
  }

  ._11N04 {
    width: 100vw;
    height: 100vh;
  }

  ._2Yv4j svg {
    /* width: 37px;
      font-size: 34px; */
  }

  ._1lgEi {
    left: 2%;
    padding-right: 2vw;
  }

  ._DDceb {
    right: 0.4%;
  }

  
  ._15MH_ {
    width: 78vw;
  }

  ._3JYCS {
    left: 1%;
  }

  ._1jASN {
    gap: 8px;
  }
}

@media screen and (min-width: 53em) {
  
  ._1yWyS {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  ._2b4P7 ._1yWyS, ._31Tcx ._1yWyS  {
    padding-top: 12vh;
  }


  ._3A0RO {
      /* height: 70vh; */
  }

  ._1R214 {
    width: 95px;
    max-width: 80px;
  } 

  ._15MH_ {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  ._1JRT_ img {
    /* width: 60vw; */
  }

  ._11N04 img {
    width: 100vw;
  }
}

._1kIQ4,
._1kIQ4 svg {
  background-color: white;
  color: black;
}

._1kIQ4:hover,
._1kIQ4 svg:hover {
  background-color: white;
  color: black;
}

._1qbJe,
._1qbJe svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
}

._1qbJe:hover,
._1qbJe svg:hover {
  color: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
._3DIHj svg {
  background-color: white;
  color: black;
}

._3DIHj svg:hover {
  background-color: white;
  color: black;
  color: rgb(24, 24, 24, 0.8);
}

._11aT5 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
}

._11aT5 svg:hover {
  color: rgba(99, 99, 99, 0.8);
}

._mdJQi {
  object-fit: contain;
}

._3pfLz ._3sodH {
  border: solid rgb(107, 133, 206) 2px;
}

._3bkUp {
  border: solid transparent 2px;
}

._3pfLz {
  width: 95%;
}

._32vVi {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 29em) {
  ._11N04 img {
    object-fit: cover;
  }

  ._32vVi {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }

  ._sqvn- {
    margin-top: 5vh;
  }

  ._3pfLz {
    width: 98%;
  }

  ._1R214 {
    width: 80px;
    max-width: 80px;
  }

  ._z-jNd video {
    max-height: 65vh;
  }

  ._qtY0U {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  ._1P3Wc {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  ._z-jNd {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  ._2Yv4j {
    position: fixed;
    left: 115px;
  }

  ._1ni2w {
    top: 3%;
  }

  ._DDceb,
  ._1lgEi {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  ._DDceb {
    padding-left: 4vw;
  }

  ._1lgEi {
    padding-right: 4vw;
  }

  ._2Yv4j {
    /* font-size: 28px; */
  }


}

@media screen and (max-width: 53em) {
  ._1yWyS {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._1yWyS img {
    margin-left: auto;
    margin-right: auto;
  }

  ._2yYOi {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._hWNoE {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  ._21mY1 {
    object-fit: contain;
  }

}

._11N04 img {
  object-fit: cover;
}

._3pfLz {
  text-align: center;
  white-space: nowrap;
}

._3Id1- {
  margin-left: auto;
  margin-right: auto;
}

._mdJQi {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
._3qqrl {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 50%;
  left: 50%;
  animation: _1hUzk 1s linear infinite;
}

@keyframes _1hUzk {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

._1itZw {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

._2TI_i {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

._3A0RO {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

._ABXHD button, ._2kumA, ._3aFDN {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

._ABXHD svg {
  box-sizing: border-box;
}

._2kumA svg, ._3aFDN svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

._2kumA {
  padding-top: 3px;
}

._3aFDN {
  cursor: pointer;

}

._3aFDN svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

._1nxK_ {
  bottom: 0%;
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

._Fp_rP {
  margin-top: 0em;
}

._238y5 {
  top: 7%;
}

._238y5._2b4P7 {
  top: 0;
}

._wTR3b {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
._3pfLz::-webkit-scrollbar {
  display: none;
}

._2FvXV {
  border-radius: 20px;
}

._oa5b0 {
  max-width: 100%;
}

._z-bHV {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  ._2Yv4j {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  ._2Yv4j {
    position: fixed;
    left: 180px;
  }
}

@media screen and (max-width: 440px) {
  ._2Yv4j {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  ._2Yv4j {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  ._2Yv4j {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  ._2Yv4j {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  ._2Yv4j {
    position: fixed;
    left: 82px;
  }
}

@media screen and (max-width: 325px) {
  ._2Yv4j {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  ._2Yv4j {
    position: fixed;
    left: 30px;
  }
}

._hGbhv {
  margin-left: auto;
  margin-right: auto;
}

[class^='number-slide'],
[class*=' number-slide'] {
  background: grey;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: #fff;
  font-weight: 500;
  height: 300px;
  max-height: 100vh;
}

._1dVqh {
  position: relative;
}

._3MuXE {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

._3U2py {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

._3U2py:focus {
  outline: none;
}

._3U2py._3sodH {
  background: #000;
}

._35l6Q {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

._1I4Zg {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._1lqBv {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._35l6Q:hover {
  color: rgb(230, 230, 230);
}

._37Xda,
._37Xda:hover {
  color: rgba(255, 255, 255, 0.5);
}

._1LtID {
  margin-top: 12px;
}

._2y9OU {
  border: 'solid transparent 2px';
}

._2oAIc {
  width: 100%;
  height: 100%;
}

._2oAIc iframe {
  width: 100%;
  height: 100%;
}

._2-c5L {
  height: 100%;
}

._30i9K iframe {
  margin: none;
  padding: none;
  border: none;
}

._1Bey- {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

._3pfLz {
  margin-left: auto;
  margin-right: auto;
}

._3xuz3 {
  cursor: pointer;
}

._1fpgA > * { color: inherit; fill: inherit }

._1cifY {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

._1mBUR {
  overflow: hidden;
  width: 100vw;
}

._Bqct9 {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

._39UN- {
  width: 78vw;
  max-width: 78vw;
}

._lqLcV ._1eJNe {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

._1tmVU {
  overflow: hidden;
}

._3-Y1e {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

._3-Y1e::before, ._3-Y1e::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


._jp0uN {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

._3S-ie {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

._1afvv {
  margin-left: auto;
}

._1HGLk {
  color: white;
}

._1TshF {
  display: flex;
}

._1HGLk {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

._U_FmQ {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

._1Y4P9 {
  padding-left: 7vw;
}

._1Y4P9 span {
  display: block;
}


._1vmhr {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
._3djxx {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Konqueror HTML */ /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

._2UUxD {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

._2UUxD img {
  pointer-events: none;
}

._gMqOZ {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

._1KxdK {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

._1mIvU._Bqct9 {
  transform: none !important; /* override Embla */
  display: flex;
  height: 250px;
}

._1mIvU._1eJNe {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

._1mIvU._1eIZ- {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

._1mIvU._1eJNe:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./node_modules/lightbox.js-react/dist/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;GAOG;;AAEH;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,eAAe;EACf,+BAA+B;AACjC;;AAEA,yEAAyE;AACzE;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,MAAM;EACR;;EAEA;IACE,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EAEd,iBAAiB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;UAEjB,iBAAiB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;;;AAIA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;8BAC4B;EAC5B,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;;EAEvB;;;AAGF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;;;;KAOG;;;;EAIH;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE;wBACoB;EACtB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IAEK,mBAAmB;EACxB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,aAAa,EAAE,sBAAsB;EACvC;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE;wBACoB;EACtB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;MACI,kBAAkB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAEK,mBAAmB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE;IAEK,iBAAiB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,WAAW;EACb;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;;AAGF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IAEK,mBAAmB;EACxB;;AAEF;;AAEA;EAEK,iBAAiB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;;EAEtB,kBAAkB;;EAElB,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc,cAAc,EAAE,cAAc;;AAE5C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB;CACD;AACD;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,WAAW;EACX;;uBAEqB;EACrB,6BAA6B;;AAE/B;;AAEA;EACE,WAAW,GAAG,0BAA0B;EACxC,YAAY,EAAE,0CAA0C;AAC1D;;;AAGA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EAER,iBAAiB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACd,YAAY,EAAE,mBAAmB,EAAE,2BAA2B;EACtF,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B,EAAE,mBAAmB;EAC/C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,kBAAkB,EAAE,mBAAmB;EACvC,mBAAmB,EAAE,mBAAmB;EACxC,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC","sourcesContent":["._30i9K {\n  margin: 0;\n  padding: 0;\n}\n\n._30i9K * {\n  box-sizing: border-box;\n}\n\n/* .lightboxjs img,\n.lightboxjs svg,\n.lightboxjs video {\n  display: block;\n  vertical-align: middle;\n  height: auto;\n  max-width: 100%;\n} */\n\n._3kSzL {\n  background-color: black;\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n._tCjNO {\n  padding-bottom: 2px;\n}\n\n._2IJEr:hover,\n._2IJEr:focus,\n._2Yv4j svg:hover,\n._2Yv4j svg:focus,\n._1lgEi span:hover,\n._DDceb:hover,\n._2Vept:hover {\n  text-decoration: none;\n  cursor: pointer;\n  /* color: rgb(230, 230, 230); */\n}\n\n/* On hover, add a black background color with a little bit see-through */\n._2gxOL:hover,\n._3gp2w:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: rgb(230, 230, 230);\n}\n\n._2crlL {\n  display: flex;\n}\n\n._34QvR {\n  display: none;\n}\n\n._1R214 {\n  opacity: 1;\n  transition: all 0.3s;\n  cursor: pointer;\n  position: relative;\n}\n\nimg._3EuZy {\n  transition: 0.3s;\n}\n\n._3EuZy:hover {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n._DDceb {\n  right: 1%;\n  padding-left: 2vw;\n  padding-right: 3vw;\n}\n\n._1lgEi {\n  left: 2%;\n  padding-right: 2vw;\n}\n\n\n._3pfLz {\n  transition: border 0.3s;\n}\n\n._1R214 {\n  display: inline;\n}\n\n._Fp_rP {\n  width: 90%;\n}\n\n._1jASN {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n/* Mobile screens */\n@media screen and (min-width: 20em) {\n  ._22ETc {\n    height: 67vw;\n    width: 60%;\n  }\n\n  ._-wN_b {\n    position: fixed;\n    bottom: 5%;\n    width: 100vw;\n    /* width: 100%; */\n  }\n\n  ._2b4P7 ._1yWyS {\n    height: 100vh;\n  }\n\n\n  ._2b4P7 ._1JRT_ {\n    top: 0;\n  }\n\n  ._1R214 {\n    width: 80px;\n    max-width: 80px;\n    height: 7vh;\n  }\n\n  ._KbOLW {\n    bottom: 2%;\n  }\n\n  ._1j-pZ {\n    padding-bottom: 16px;\n    width: 100vw;\n  }\n\n  ._3pfLz {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  ._DDceb {\n    right: 0.9%;\n  }\n\n  ._1lgEi {\n    left: 1.5%;\n  }\n}\n\n._1R214 {\n  height: 5vh;\n  border-radius: 6px;\n  margin-right: 7px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n._-wN_b {\n  position: absolute;\n  bottom: 10%;\n  height: 5vh;\n  width: 100vw;\n  z-index: 10000000;\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n\n._1Odla {\n  width: 78vw;\n}\n\n._KbOLW {\n  bottom: 5%;\n}\n\n._1nxK_ {\n  height: 19vh;\n}\n\n._z-jNd video {\n  height: 100%;\n  max-height: 70vh;\n  width: 100%;\n}\n\n._2jJU2 {\n  position: absolute;\n  bottom: 14%;\n  width: 100vw;\n  z-index: 10000000;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._lY1R_ {\n  cursor: pointer;\n  margin: 0.2em;\n}\n\n._PH6f8 {\n  width: 99vw;\n  height: 100%;\n  max-height: 100%;\n  direction: ltr;\n  overflow: hidden;\n  touch-action: none;\n  padding: 0;\n  overflow-y: hidden;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n}\n\n._wTR3b {\n  height: 100%;\n  max-height: 100%;\n  direction: ltr;\n  overflow: hidden;\n  touch-action: none;\n  padding: 0;\n  overflow-y: hidden;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* position: fixed; */\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n}\n\n._11N04 img {\n  height: 100vh;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n._20Hp6 img {\n  height: 80vh;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n._20Hp6 {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  top: 0;\n  align-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  z-index: 1000000;\n}\n\n._3PObS {\n  margin-bottom: 3em;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._1JRT_ {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: top 0.2s ease-in-out 0s;\n  top: 10%;\n  align-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  z-index: 1000000;\n}\n\n._29Kdn {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n._1ni2w {\n  top: 6%;\n}\n\n._GV0NM {\n  top: 12%;\n}\n\n._2b4P7  {\n  top: 0;\n}\n\n._11N04 {\n  top: 0;\n}\n\n._3BNPD {\n  width: 100vw;\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n._DDceb,\n._1lgEi {\n  top: calc(50% - 20px);\n  position: absolute;\n  display: flex;\n  transition: all 0.2s;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 2vh;\n  padding-top: 2vh;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  font-weight: bold;\n  border-radius: 30px;\n  width: 40px;\n  height: 40px;\n  font-size: 18px;\n  z-index: 10000000;\n}\n\n\n\n._DDceb:hover,\n._1lgEi:hover {\n  color: rgb(230, 230, 230);\n}\n\n._j1nqC {\n  position: absolute;\n  max-width: 100vw;\n}\n\n._ABXHD {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n._2Yv4j {\n  color: white;\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  /* align-items: center;\n    justify-content: center; */\n  cursor: pointer;\n  top: 10px;\n  right: 45px;\n  z-index: 999999999;\n  /* padding: 0.14vw; */\n}\n\n._2eq8V {\n  aspect-ratio: 16 / 9;\n  height: 65vh;\n  width: 100%;\n}\n\n._1P3Wc {\n  width: 65%;\n  margin-left: auto;\n  margin-right: auto;\n  height: 60vh;\n  max-height: 65vh;\n}\n\n._z-jNd {\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._Aq8HC, ._w68I8 {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._qtY0U {\n  position: fixed;\n  top: 4%;\n  right: 3%;\n}\n\n._3cxVN ._2Yv4j svg {\n  transition: 0.3s all;\n}\n\n._2Yv4j svg:active {\n  transform: scale(0.97);\n}\n\n._2pA2G {\n  text-align: center;\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._2Yv4j svg {\n  margin-left: 0.6em;\n  padding: 0.2em;\n  transition: all 0.1s;\n  /* width: 32px;  */\n  /* font-size: 18px; */\n  line-height: 16px;\n  vertical-align: baseline;\n}\n\n._2Vept {\n  /* width: 32px;  */\n}\n\n@media screen and (min-width: 6em) {\n  ._2Yv4j {\n    top: 3%;\n  }\n\n  ._wTR3b {\n    width: 100vw;\n  }\n\n  ._2Yv4j svg {\n    /* width: 34px;  */\n    padding-right: 0.3em;\n  }\n\n  ._30i9K img {\n    cursor: pointer;\n  }\n\n  ._1R214 {\n    height: 9vh;\n    /* width: 22vw; */\n  }\n\n  ._DDceb {\n    top: calc(48% - 20px);\n  }\n\n  ._1lgEi {\n    top: calc(48% - 20px);\n\n  }\n\n\n}\n\n@media screen and (min-width: 39em) {\n  ._wTR3b {\n    width: 100vw;\n  }\n\n  ._1JRT_ {\n    width: 100vw;\n    height: 95vh;\n    position: absolute;\n  }\n\n  ._1j-pZ {\n    padding-bottom: 0px;\n  }\n\n  ._DDceb {\n    right: 0.7%;\n  }\n\n  /* .hideControlsBar .slideshow_img {\n    height: 70vh;\n\n  }\n\n  .hideControlsBar {\n    top: 10%;\n  } */\n\n\n\n  ._11N04 {\n    width: 100vw;\n    height: 100vh;\n  }\n\n  ._11N04 img {\n    height: 100vh;\n  }\n\n  ._3pfLz {\n    margin-top: 0.6em;\n  }\n\n  ._1R214 {\n    /* height: 8vh; */\n    width: 80px;\n    max-width: 80px;\n  }\n\n  ._2Yv4j svg {\n    /* width: 32px; \n      font-size: 32px; */\n  }\n\n  ._1lgEi {\n    left: 2.7%;\n    padding-right: 2vw;\n  }\n}\n\n/* Desktop screens */\n@media screen and (min-width: 42em) {\n  ._22ETc {\n    height: 70vh;\n    width: 80vw;\n  }\n\n  ._2yYOi {\n    display: grid;\n    width: 92vw;\n    place-items: start;\n    margin-left: auto;\n    margin-right: auto;\n    scrollbar-gutter: stable both-edges;\n  }\n\n  ._1JRT_ img {\n    margin-top: 0vh;\n    /* width: 70vw; */\n  }\n\n  ._11N04 img {\n    width: 100vw;\n  }\n\n  ._hWNoE {\n    top: 0%;\n  }\n\n  ._1ek8k {\n    margin-left: auto;\n    margin-right: auto;\n    height: 100vh;\n  }\n\n  ._hWNoE {\n    height: 100vh;\n    width: 100vw;\n    position: absolute;\n  }\n\n  ._hWNoE img {\n    -o-object-fit: contain;\n       object-fit: contain;\n  }\n\n  ._3pfLz {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    margin-top: 1.1em;\n  }\n\n  ._3pfLz::-webkit-scrollbar {\n    display: none; /* Safari and Chrome */\n  }\n\n  ._2P48G {\n    transition: opacity 0.3s;\n    -webkit-transition: opacity 0.3s;\n    opacity: 1;\n  }\n\n  ._-wN_b {\n    margin-top: 0.1em;\n    padding-top: 0.3em;\n    height: 5vh;\n    bottom: 11%;\n    /* width: 90vw; */\n  }\n\n  ._1R214,\n  ._1xBL9 img {\n    height: 10vh;\n    /* width: 7em; */\n  }\n\n  ._wTR3b {\n    width: 100vw;\n  }\n\n  ._1JRT_ {\n    width: 100vw;\n    height: 95vh;\n  }\n\n  ._2b4P7 {\n    height: 100vh;\n  }\n\n  ._11N04 {\n    width: 100vw;\n    height: 100vh;\n  }\n\n  ._2Yv4j svg {\n    /* width: 37px;\n      font-size: 34px; */\n  }\n\n  ._1lgEi {\n    left: 2%;\n    padding-right: 2vw;\n  }\n\n  ._DDceb {\n    right: 0.4%;\n  }\n\n  \n  ._15MH_ {\n    width: 78vw;\n  }\n\n  ._3JYCS {\n    left: 1%;\n  }\n\n  ._1jASN {\n    gap: 8px;\n  }\n}\n\n@media screen and (min-width: 53em) {\n  \n  ._1yWyS {\n    display: grid;\n    width: 100vw;\n    height: 70vh;\n    place-items: start;\n    /* margin-top: 7vh; */\n  }\n\n  ._2b4P7 ._1yWyS, ._31Tcx ._1yWyS  {\n    padding-top: 12vh;\n  }\n\n\n  ._3A0RO {\n      /* height: 70vh; */\n  }\n\n  ._1R214 {\n    width: 95px;\n    max-width: 80px;\n  } \n\n  ._15MH_ {\n    width: 78vw;\n  }\n}\n  \n\n@media screen and (min-width: 80em) {\n  ._1JRT_ img {\n    /* width: 60vw; */\n  }\n\n  ._11N04 img {\n    width: 100vw;\n  }\n}\n\n._1kIQ4,\n._1kIQ4 svg {\n  background-color: white;\n  color: black;\n}\n\n._1kIQ4:hover,\n._1kIQ4 svg:hover {\n  background-color: white;\n  color: black;\n}\n\n._1qbJe,\n._1qbJe svg {\n  background-color: transparent;\n  /* background-color: #151515; */\n  color: silver;\n}\n\n._1qbJe:hover,\n._1qbJe svg:hover {\n  color: rgba(107, 107, 107, 0.8);\n}\n\n/* Header icons  */\n._3DIHj svg {\n  background-color: white;\n  color: black;\n}\n\n._3DIHj svg:hover {\n  background-color: white;\n  color: black;\n  color: rgb(24, 24, 24, 0.8);\n}\n\n._11aT5 svg {\n  background-color: transparent;\n  /* background-color: #151515; */\n  color: #626b77;\n}\n\n._11aT5 svg:hover {\n  color: rgba(99, 99, 99, 0.8);\n}\n\n._mdJQi {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n._3pfLz ._3sodH {\n  border: solid rgb(107, 133, 206) 2px;\n}\n\n._3bkUp {\n  border: solid transparent 2px;\n}\n\n._3pfLz {\n  width: 95%;\n}\n\n._32vVi {\n  --thumbs-slide-spacing: 2px; \n  /* --thumbs-slide-height: 9rem; */\n  margin-top: var(--thumbs-slide-spacing);\n}\n\n@media screen and (max-width: 29em) {\n  ._11N04 img {\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n\n  ._32vVi {\n    --thumbs-slide-spacing: 3px; \n    /* --thumbs-slide-height: 9rem; */\n    margin-top: var(--thumbs-slide-spacing);\n  }\n\n  ._sqvn- {\n    margin-top: 5vh;\n  }\n\n  ._3pfLz {\n    width: 98%;\n  }\n\n  ._1R214 {\n    width: 80px;\n    max-width: 80px;\n  }\n\n  ._z-jNd video {\n    max-height: 65vh;\n  }\n\n  ._qtY0U {\n    position: fixed;\n    top: 2%;\n    right: 15px;\n  }\n\n  ._1P3Wc {\n    width: 88%;\n    margin-left: auto;\n    margin-right: auto;\n    height: 100%;\n    max-height: 65vh;\n  }\n\n  ._z-jNd {\n    width: 94%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  ._2Yv4j {\n    position: fixed;\n    left: 115px;\n  }\n\n  ._1ni2w {\n    top: 3%;\n  }\n\n  ._DDceb,\n  ._1lgEi {\n    padding-bottom: 2vh;\n    padding-top: 2vh;\n  }\n\n  ._DDceb {\n    padding-left: 4vw;\n  }\n\n  ._1lgEi {\n    padding-right: 4vw;\n  }\n\n  ._2Yv4j {\n    /* font-size: 28px; */\n  }\n\n\n}\n\n@media screen and (max-width: 53em) {\n  ._1yWyS {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 100vw;\n    height: 70vh;\n  }\n\n  ._1yWyS img {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  ._2yYOi {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 100vw;\n    height: 70vh;\n  }\n\n  ._hWNoE {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    transition: top 0.2s ease-in-out 0s;\n    top: 10%;\n    align-content: center;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    z-index: 1000000;\n  }\n\n  ._21mY1 {\n    -o-object-fit: contain;\n       object-fit: contain;\n  }\n\n}\n\n._11N04 img {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n._3pfLz {\n  text-align: center;\n  white-space: nowrap;\n}\n\n._3Id1- {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._mdJQi {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* CSS loader  */\n._3qqrl {\n  width: 44px;\n  height: 44px;\n  box-sizing: border-box;\n\n  border-radius: 50%;\n\n  display: inline-block;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  animation: _1hUzk 1s linear infinite;\n}\n\n@keyframes _1hUzk {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n._1itZw {\n  border: 5px solid #626b77;\n  border-bottom-color: transparent;\n}\n\n._2TI_i {\n  border: 5px solid #fff;\n  border-bottom-color: transparent;\n}\n\n._3A0RO {\n  max-height: 70vh;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._ABXHD button, ._2kumA, ._3aFDN {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n._ABXHD svg {\n  box-sizing: border-box;\n}\n\n._2kumA svg, ._3aFDN svg {\n  box-sizing: border-box;\n  font-size: 16px;\n  padding-top: 0.5px;\n}\n\n._2kumA {\n  padding-top: 3px;\n}\n\n._3aFDN {\n  cursor: pointer;\n\n}\n\n._3aFDN svg {\n  margin: 0;\n  padding: 5px;\n  background-color: black;\n  border-color: transparent;\n  border-radius: 28px;\n\n}\n\n._1nxK_ {\n  bottom: 0%;\n  height: 19vh;\n  margin-top: 0em;\n  width: 100vw;\n}\n\n._Fp_rP {\n  margin-top: 0em;\n}\n\n._238y5 {\n  top: 7%;\n}\n\n._238y5._2b4P7 {\n  top: 0;\n}\n\n._wTR3b {\n  -ms-overflow-style: none;\n  /* scrollbar-width: none;   */\n}\n._3pfLz::-webkit-scrollbar {\n  display: none;\n}\n\n._2FvXV {\n  border-radius: 20px;\n}\n\n._oa5b0 {\n  max-width: 100%;\n}\n\n._z-bHV {\n  max-width: 80%;\n}\n\n@media screen and (max-width: 880px) {\n  ._2Yv4j {\n    position: fixed;\n    right: 5%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 180px;\n  }\n}\n\n@media screen and (max-width: 440px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 160px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 140px;\n  }\n}\n\n@media screen and (max-width: 385px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 135px;\n    /* top: 24px; */\n  }\n}\n\n@media screen and (max-width: 365px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 90px;\n  }\n}\n\n@media screen and (max-width: 345px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 82px;\n  }\n}\n\n@media screen and (max-width: 325px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 60px;\n  }\n}\n\n@media screen and (max-width: 300px) {\n  ._2Yv4j {\n    position: fixed;\n    left: 30px;\n  }\n}\n\n._hGbhv {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n[class^='number-slide'],\n[class*=' number-slide'] {\n  background: grey;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 50px;\n  color: #fff;\n  font-weight: 500;\n  height: 300px;\n  max-height: 100vh;\n}\n\n._1dVqh {\n  position: relative;\n}\n\n._3MuXE {\n  display: flex;\n  padding: 10px 0;\n  justify-content: center;\n}\n\n._3U2py {\n  border: none;\n  width: 10px;\n  height: 10px;\n  background: #c5c5c5;\n  border-radius: 50%;\n  margin: 0 5px;\n  padding: 5px;\n  cursor: pointer;\n}\n\n._3U2py:focus {\n  outline: none;\n}\n\n._3U2py._3sodH {\n  background: #000;\n}\n\n._35l6Q {\n  position: absolute;\n  top: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  transition: all 0.2s;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  color: #fff;\n  cursor: pointer;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: sans-serif;\n}\n\n._1I4Zg {\n  left: 8px;\n  padding-right: 10px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n._1lqBv {\n  left: auto;\n  right: 8px;\n  padding-left: 10px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n._35l6Q:hover {\n  color: rgb(230, 230, 230);\n}\n\n._37Xda,\n._37Xda:hover {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n._1LtID {\n  margin-top: 12px;\n}\n\n._2y9OU {\n  border: 'solid transparent 2px';\n}\n\n._2oAIc {\n  width: 100%;\n  height: 100%;\n}\n\n._2oAIc iframe {\n  width: 100%;\n  height: 100%;\n}\n\n._2-c5L {\n  height: 100%;\n}\n\n._30i9K iframe {\n  margin: none;\n  padding: none;\n  border: none;\n}\n\n._1Bey- {\n  z-index: 100000;\n  background-color: transparent;\n  border: none;\n}\n\n._3pfLz {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._3xuz3 {\n  cursor: pointer;\n}\n\n._1fpgA > * { color: inherit; fill: inherit }\n\n._1cifY {\n  margin-left: auto;\n  margin-right: auto;\n  --slide-spacing: 1rem;\n  --slide-size: 100%;\n  --slide-height: 19rem;\n}\n\n._1mBUR {\n  overflow: hidden;\n  width: 100vw;\n}\n\n._Bqct9 {\n  backface-visibility: hidden; \n  touch-action: pan-y;\n  height: auto;\n  margin-left: calc(var(--slide-spacing) * -1);\n  display: grid;  \n  grid-auto-flow: column;  \n  grid-auto-columns: 100%; \n  max-width: 100vw;\n  margin-left: auto;\n  margin-right: auto; \n  /* width: 80%;\n*/\n}\n\n._39UN- {\n  width: 78vw;\n  max-width: 78vw;\n}\n\n._lqLcV ._1eJNe {\n  flex: 0 0 80%;\n  min-width: 0;\n  max-width: 100%;\n  padding-left: 12px;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n._1tmVU {\n  overflow: hidden;\n}\n\n._3-Y1e {\n  display: flex;\n  flex-direction: row;\n  margin-left: calc(var(--thumbs-slide-spacing) * -1);\n  width: 100%;\n  /* align-items: center;\n  text-align: center;\n  width: fit-content; */\n  /* justify-content: center; */\n  \n}\n\n._3-Y1e::before, ._3-Y1e::after {\n  content: '';  /* Insert pseudo-element */\n  margin: auto; /* Make it push flex items to the center */\n}\n\n\n._jp0uN {\n  /* min-width: 0; */\n  padding-left: var(--thumbs-slide-spacing);\n  /* position: relative; */\n  /* width: 140px; */\n}\n\n._3S-ie {\n  /* display: block; */\n  height: var(--thumbs-slide-height);\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n._1afvv {\n  margin-left: auto;\n}\n\n._1HGLk {\n  color: white;\n}\n\n._1TshF {\n  display: flex;\n}\n\n._1HGLk {\n  text-align: left;\n  min-width: 17vw;\n  max-width: 17vw;\n  padding-top: 5vw;\n}\n\n._U_FmQ {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n._1Y4P9 {\n  padding-left: 7vw;\n}\n\n._1Y4P9 span {\n  display: block;\n}\n\n\n._1vmhr {\n  position: absolute;\n  top: 1%;\n  right: 2%;\n  background: none;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n/* Styling from react-zoom-pan-pinch library */\n._3djxx {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */ /* Konqueror HTML */ /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n\n._2UUxD {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n\n._2UUxD img {\n  pointer-events: none;\n}\n\n._gMqOZ {\n  height: 10px;\n  width: 10px;\n  background-color: silver;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n}\n\n._1KxdK {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n._1mIvU._Bqct9 {\n  transform: none !important; /* override Embla */\n  display: flex;\n  height: 250px;\n}\n\n._1mIvU._1eJNe {\n  flex: 0 0 auto;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0 !important; /* override Embla */\n  right: 0 !important; /* override Embla */\n  opacity: 0;\n  transition: opacity 0.5s;\n  counter-increment: embla;\n  border-radius: 0.5rem;\n}\n\n._1mIvU._1eIZ- {\n  opacity: 1;\n  transition: opacity 0.3s;\n  z-index: 1;\n}\n\n._1mIvU._1eJNe:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
